module.exports = __webpack_public_path__ + "img/OrderDefault.f10b6ab2.svg";